import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import {
  ICreateCertificationRequest,
  IEditCertificationRequest,
} from '../../../models/CreateCertification'
import { ROUTES } from '../../../module/constants'

export interface ICreateCertificationProps {
  changeLocation: (url: string) => {}
  setTriggerConfirmModal: (payload: any) => void
  callState: IResponseState
  confirmModalTrigger: boolean
  requestCreateCertification: ICreateCertificationRequest
  createCertificationRequest: (payload: ICreateCertificationRequest) => {}
  editCertificationRequest: (payload: IEditCertificationRequest) => {}
  selectedCertification: any
  resetStateCreateEditCertification: () => {}
}

export const CREATE_CERTIFICATION_URL = {
  BASE_URL: ROUTES.CREATE_CERTIFICATION,
  STEP_TWO: `${ROUTES.CREATE_CERTIFICATION}/step-two`,
  STEP_THREE: `${ROUTES.CREATE_CERTIFICATION}/step-three`,
  STEP_FOUR: `${ROUTES.CREATE_CERTIFICATION}/step-four`,
  STEP_FIVE: `${ROUTES.CREATE_CERTIFICATION}/step-five`,
  STEP_SIX: `${ROUTES.CREATE_CERTIFICATION}/step-six`,
  STEP_SEVEN: `${ROUTES.CREATE_CERTIFICATION}/step-seven`,
  STEP_EIGHT: `${ROUTES.CREATE_CERTIFICATION}/step-eight`,
  STEP_NINE: `${ROUTES.CREATE_CERTIFICATION}/step-nine`,
  STEP_TEN: `${ROUTES.CREATE_CERTIFICATION}/step-ten`,
}

export const CREATE_CERTIFICATION_IDENTIFIER = {
  STEP_ONE: 'stepOne',
  NAME: 'name',
  DESCRIPTION: 'description',
  TYPE: 'type',
  OPERATION: 'operation',
  VALIDATION: 'validation',
  BR_INCLUDED: 'businessRolesIncluded',
  BAO_REVISOR: 'baoRevisor',
  EVERY_DAY_COMPUTATION_ACTIVE: 'everyDayDatasetComputationActive',
  MANAGER_REVISOR_LOGIC_APPLIED: 'managerRevisorLogicApplied',
  STEP_TWO: 'stepTwo',
  SUPERVISORS: 'supervisors',
  STEP_THREE: 'stepThree',
  ADDED_SUPERVISORS: 'addedSupervisors',
  REVISOR_SELECTED: 'revisorSelected',
  REVISORS: 'revisors',
  STEP_FOUR: 'stepFour',
  START_DATE: 'startDate',
  TOLERANCE: 'tolerance',
  SEQUENCE: 'sequence',
  DURATION: 'duration',
  STEP_FIVE: 'stepFive',
  GROUPS: 'groups',
  ADDED_GROUPS: 'addedGroups',
  STEP_SIX: 'stepSix',
  USERS: 'users',
  ADDED_USERS: 'addedUsers',
  STEP_SEVEN: 'stepSeven',
  APPLICATIONS: 'applications',
  ADDED_APPLICATIONS: 'addedApplication',
  STEP_EIGHT: 'stepEight',
  BR: 'BR',
  ADDED_BR: 'addedBR',
  STEP_NINE: 'stepNine',
  ENTITLEMENTS: 'entitlements',
  ADDED_ENTITLEMENTS: 'addedEntitlements',
  CALL_STATE: 'callState',
  CONFIRM_MODAL_TRIGGER: 'confirmModalTrigger',
  SELECTED_CERTIFICATION: 'selectedCertification',
  ENRICHMENT_SELECTED_CERTIFICATION: 'enrichmentSelectedCertification',
  ALREADY_SET: 'alreadySet',
  STEP_TEN: 'stepTen',
  TECHNCIAL_USERS: 'technicalUsers',
  ADDED_TECHNCIAL_USERS: 'addedTechnicalUsers',
}

export const LIST_IDENTIFIER: string = 'list'
export const LOADER_IDENTIFIER: string = 'loader'
export const BLACK_IDENTIFIER: string = 'blackList'
export const WHITE_IDENTIFIER: string = 'whiteList'
export const TAB_SELECTED_IDENTIFIER: string = 'tabSelected'

export enum typeListLabel {
  USER = 'USER',
  OU = 'OU',
  BUSINESS_ROLE = 'BUSINESS_ROLE',
  ACCOUNT = 'ACCOUNT',
  TECHNICAL_USER = 'TECHNICAL_USER',
  Robot = 'Robot',
  Service = 'Service',
}
export interface ITypeItem {
  value: number
  label: string
}

export const typeList: number[] = [1, 2, 3, 4, 5]

export const typeListVal: { [index: number]: string } = {
  1: 'USER',
  2: 'OU',
  3: 'BUSINESS_ROLE',
  4: 'ACCOUNT',
  5: 'TECHNICAL_USER',
  6: 'Robot',
  7: 'Service',
}

export const periodTolerance: number[] = [0, 5, 10, 30, 100]

export const durationCampaign: number[] = [1, 3, 6, 12]

export const sequenceCampaign: number[] = [1, 2, 3]

export const WHITE_TAB: 'BLACK' | 'WHITE' = 'WHITE'
export const BLACK_TAB: 'BLACK' | 'WHITE' = 'BLACK'

export enum perimeterObjectType {
  APPLICATION = 'APPLICATION',
  OU = 'OU',
  BR = 'BUSINESS_ROLE',
  ENTITLEMENT = 'ENTITLEMENT',
  USER = 'USER',
  TECHNICAL_USER = 'TECHNICAL_USER',
  Robot = 'Robot',
  Service = 'Service',
}
